import { Controller } from 'stimulus';
import debounce from '@/helpers/debounce';

class CloudsController extends Controller {
  connect() {
    this.setHeightDebounced = debounce(this.setHeight.bind(this), 200);
    this.setHeight();
  }

  onWindowResize() {
    this.setHeightDebounced();
  }

  setHeight() {
    const height = CloudsController.calculateHeight();

    this.element.style.height = `${height}px`;
  }

  static calculateHeight() {
    let height = 0;
    const header = document.querySelector('.header');
    const hero = document.querySelector('.hero');

    if (header) {
      height += header.offsetHeight;
    }

    if (hero) {
      height += hero.offsetHeight;
    } else {
      height += document.querySelector('main').offsetHeight;
    }

    return height;
  }
}

CloudsController.targets = [];

export default CloudsController;
